export const {
  // APP
  REACT_APP_GTM_ID: gtmId,
  REACT_APP_URL: baseUri,
  REACT_APP_SHOW_ERRORS: currentEnv,
  // RUM
  REACT_APP_RUM_APPLICATION_ID: applicationId,
  REACT_APP_RUM_CLIENT_TOKEN: clientToken,
  REACT_APP_RUM_SITE: site,
  REACT_APP_RUM_ENV: env,
  REACT_APP_RUM_SSR: sessionSampleRate,
  REACT_APP_RUM_PSR: premiumSampleRate,
} = process.env;
export const TOKEN_VALIDATE = `${baseUri}/validate-token`;
export const CUSTOMER_LITE = `${baseUri}/customer/lite`;
export const BANNERS = `${baseUri}/banners?banner_location=pwa`;
export const EXTRA_POINTS = `${baseUri}/customer/extras`;
export const MOVEMENTS = `${baseUri}/customer/transactions`;
export const PUNCH_CARDS = `${baseUri}/customer/punchcards`;
export const REWARDS = `${baseUri}/customer/rewards`;
export const AWARDS = `${baseUri}/customer/awards`;
export const STARS_GET = `${baseUri}/stars-campaigns`;
export const STARS_ENROLLED = `${baseUri}/customer/stars-campaigns`;
export const STARS_WINNERS = `${baseUri}/winners/stars-campaigns`;
export const generateImg = (resolution, text) =>
  `https://dummyimage.com/${resolution}/000/fff&text=${text}`;
export const buildMexicoStates = (lon = [], res = []) => {
  for (let i = 0; i < lon.length; i++)
    res.push({ value: lon[i], label: lon[i] });
  return res;
};
// Tokens allowed
export const headerKeysAllowed = {
  oxxo: "token",
  spin: "spin-authorization",
};
// Location keys
export const privSponsorKey = "SpinPremiaHeaderProvided";
export const privMemberId = "SpinPremiaMemberId";
export const privBalanceKey = "SpinPremiaMemberBalance";
export const privTokenKey = "SpinPremiaToken";
export const privTermsAccepted = "SpinPremiaTermsAccepted";
export const privIsValidToken = "SpinPremiaIsValidToken";
export const privStatePicked = "SpinPremiaStatePicked";
export const privGtmKey = "SpinPremiaGtmId";
export const privSnack = "SpinPremiaHaveSnack";
// Promotions keys
export const banners = "SpinPremiaBanners";
export const stamps = "SpinPremiaStamps";
export const rewards = "SpinPremiaRewards";
export const awards = "SpinPremiaAwards";
export const extras = "SpinPremiaExtras";
export const stars = "SpinPremiaStars";
// Requests handlers
export const setHeaders = (headers = {}, base = {}) => {
  const header = localStorage.getItem(privSponsorKey);
  const token = localStorage.getItem(privTokenKey);
  if (header === headerKeysAllowed.oxxo) {
    headers.Authorization = `Bearer ${token}`;
  } else if (header === headerKeysAllowed.spin) {
    headers.SpinAuthorization = token;
  }
  return { ...base, ...headers };
};
export const setReqOpts = (method, headers, body) => ({
  method,
  headers,
  body,
});
// Token wizard
export const tokenSolver = () => {
  const key = localStorage.getItem(privSponsorKey);
  const value = localStorage.getItem(privTokenKey);
  return `${key}=${value}`;
};
export const putInStorage = (key, value, stringify = true) => {
  const result = stringify ? JSON.stringify(value) : value;
  localStorage.setItem(key, result);
};
export const getFromStorage = (key, jsonParse = true) => {
  const rawValue = localStorage.getItem(key);
  if (!rawValue || rawValue === "undefined" || rawValue === "false") {
    return null;
  }
  return jsonParse ? JSON.parse(rawValue) : rawValue;
};
export const scrollToTop = (x = 0, y = 0) => window.scrollTo(x, y);
export const scrollToBottom = (x = 0, y = document.body.scrollHeight) =>
  window.scrollTo(x, y);
export const appVersion = () => {
  const pjson = require("./../package.json");
  const currentVersion = `v${pjson.version}`;
  return currentVersion;
};
export const isPortable = (maxMobRes = 783) => window.innerWidth <= maxMobRes;
export const isDisabled = (disabled) => (disabled ? "#C5CCD5" : "#4A90E2");
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
export const formatPrice = (qty) => <label>{formatter.format(qty)}</label>;
export const getImg = (url, classes, alt = "Recurso no encontrado") => (
  <img src={url} alt={alt} className={classes} />
);
export const drawBalance = (balance) =>
  Number(Math.floor(parseFloat(balance))).toLocaleString("en");
export const makeId = (length, result = "") => {
  const minus = "abcdefghijklmnopqrstuvwxyz";
  const mayus = minus.toUpperCase();
  const nums = "0123456789";
  const characters = mayus + minus + nums;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};
export const noFunc = (c, e) => console.log(`(${c}) function associated ${e}`);
export const defaultChildren = (n, res = []) => {
  timesGen(n).map((i) => res.push(<div key={i}>child {i} here</div>));
  return res;
};
export const defaultContent = (n, c = "Content", res = []) => {
  timesGen(n).map(() => res.push(`A Really Big ${c} To Check The Overflow`));
  return res.join(" ");
};
const timesGen = (n, res = []) => {
  for (let index = 0; index < n; index++) res.push(index + 1);
  return res;
};
export const fixContent = (content, limit) =>
  content ? content.slice(0, limit) : "";
export const stylePrice = (number) => {
  const regex = /(\d[,.])(\d{2})(?!\d)/g;
  const str = formatPrice(number).props.children;
  return str.replace(regex, "$1<sup>$2</sup>");
};
export const TermsAndConditions = ({ terms, klass }) => (
  <div
    className={`content ${klass}`}
    dangerouslySetInnerHTML={{ __html: terms }}
  />
);
export const toIntsAndDecs = (bits) => {
  return `${bits.toFixed(2)}`.split(".");
};
export const BalanceTag = ({ bits }) => {
  const units = toIntsAndDecs(bits);
  return (
    <>
      {drawBalance(units.join(","))}.<sup>{units.pop()}</sup>
    </>
  );
};
export const MovementTag = ({ bits = 0 }) => {
  const units = toIntsAndDecs(bits);
  return (
    <>
      {drawBalance(units.join(","))}.{units.pop()}
    </>
  );
};
export const DivSpace = ({ height }) => <div style={{ height }} />;
export const ExpiracyDetail = ({ expiracy = null }) => {
  if (!expiracy || expiracy === "") return null;
  const dateParts = expiracy.split("/");
  const date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  const formattedDate = date.toLocaleDateString("es-mx", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return (
    <div className="description">{`Válido hasta el ${formattedDate}`} </div>
  );
};
export const RedeemableLabel = ({ redeemable, image, label }) => {
  if (!redeemable) return null;
  return (
    <div className="ready-to-redeem">
      {getImg(image)}
      <label>{label}</label>
    </div>
  );
};
export const stampsLabel = (item, label = "") => {
  const { balance, required_balance, available_to_redeem } = item;
  if (!balance || !required_balance || !available_to_redeem) return label;
  const redeemable = balance >= required_balance || available_to_redeem >= 1;
  const balanceFixed = redeemable
    ? available_to_redeem * required_balance + balance
    : balance;
  label = `Juntaste ${balanceFixed} de ${required_balance} sellos`;
  return label;
};
export const rewardsLabel = (item, label = "") => {
  const { available_to_redeem, required_balance, balance } = item;
  if (!available_to_redeem || !required_balance || !balance) return label;
  const balanceFixed = available_to_redeem
    ? available_to_redeem * required_balance + balance
    : balance;
  const bf = stylePrice(balanceFixed);
  const rb = stylePrice(required_balance);
  label = `Llevas ${bf} de ${rb}`;
  return label;
};
export const showOnlyIfNotProd = (content) => (
  <>{currentEnv.toLowerCase() === "prod" ? null : content}</>
);
export const slugName = (text) => {
  const transformed = text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s]/gi, "")
    .replace(/[\s]/gi, "_");
  return `_${transformed}_`;
};
export const states = [
  { value: "AGS", label: "Aguascalientes" },
  { value: "BC", label: "Baja California" },
  { value: "BCS", label: "Baja California Sur" },
  { value: "CAM", label: "Campeche" },
  { value: "CHIS", label: "Chiapas" },
  { value: "CHIH", label: "Chihuahua" },
  { value: "CDMX", label: "Ciudad de México" },
  { value: "COAH", label: "Coahuila" },
  { value: "COL", label: "Colima" },
  { value: "DGO", label: "Durango" },
  { value: "EDOMEX", label: "Estado de México" },
  { value: "GTO", label: "Guanajuato" },
  { value: "GRO", label: "Guerrero" },
  { value: "HGO", label: "Hidalgo" },
  { value: "JAL", label: "Jalisco" },
  { value: "MICH", label: "Michoacán" },
  { value: "MOR", label: "Morelos" },
  { value: "NAY", label: "Nayarit" },
  { value: "NL", label: "Nuevo León" },
  { value: "OAX", label: "Oaxaca" },
  { value: "PUE", label: "Puebla" },
  { value: "QRO", label: "Querétaro" },
  { value: "QR", label: "Quintana Roo" },
  { value: "SLP", label: "San Luis Potosí" },
  { value: "SIN", label: "Sinaloa" },
  { value: "SON", label: "Sonora" },
  { value: "TAB", label: "Tabasco" },
  { value: "TAMPS", label: "Tamaulipas" },
  { value: "TLAX", label: "Tlaxcala" },
  { value: "VER", label: "Veracruz" },
  { value: "YUC", label: "Yucatán" },
  { value: "ZAC", label: "Zacatecas" },
  // { value: "N_A", label: "No muestra en reducido" },
];
// Prevents double scroll bar
export const toggleScrollLock = () =>
  document.querySelector("html").classList.toggle("modal-scroll-lock");
export const getCardDetail = (set, id) => set.find((promo) => promo.id === id);
export const printableId = (id, cloned = "") => {
  const original = `${id}`;
  for (let index = 0; index < original.length; index++) {
    if (cloned.length % 4 === 0) cloned += " ";
    cloned += original[index];
  }
  return cloned.trim();
};
export const extractDataForKey = (str, key, defaultText = "") => {
  const pattern = new RegExp(`{{\\s*${key}:\\s*(.*?)\\s*}}`);
  const match = str.match(pattern);
  return match && match[1] ? match[1] : defaultText;
};
export const deleteData = (str) => str.replace(/{{.*?}}/g, "");
